<template>
  <section class="flex flex-col sm:flex-row w-full">
    <!-- Columna izquierda: Texto -->
    <div
      class="bg-primary text-white flex flex-col justify-center w-full sm:w-1/2 p-6 sm:p-12"
    >
      <div class="max-w-xl mx-auto sm:mx-0">
        <h1
          class="text-4xl sm:text-5xl font-extrabold leading-snug sm:leading-tight mb-4"
        >
          En INBROS, tu seguridad es nuestra misión
        </h1>
        <p
          class="text-base sm:text-xl text-white/80 leading-relaxed sm:leading-loose"
        >
          Te ayudamos a elegir la cobertura perfecta para ti, tu familia o tu
          empresa.
        </p>
      </div>
    </div>

    <!-- Columna derecha: Imagen -->
    <div class="w-full sm:w-1/2">
      <img
        src="@/assets/hero-inbros.png"
        alt="Imagen Hero"
        class="w-full h-auto block"
      />
    </div>
  </section>
</template>
